import { MobileMenu } from "components/page-header/mobile-header/mobile-menu";

import { PublicHeaderNav } from "./nav";
import styles from "./public-header.module.scss";

type PublicMobileNavProps = {
  menuOpen: boolean;
  setMenuOpen: (state: boolean) => void;
};
export const PublicMobileNav = ({
  menuOpen,
  setMenuOpen,
}: PublicMobileNavProps) => {
  if (!menuOpen) return null;
  return (
    <MobileMenu onClose={() => setMenuOpen(false)} align="right">
      <div className={styles.mobileMenu}>
        <PublicHeaderNav />
      </div>
    </MobileMenu>
  );
};
